const { getOffsetTop } = window.BAO.Utils

class BrandsList extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.els?.group?.elements?.forEach((groupEl) => {
      groupEl.dataset.initialHidden =
        groupEl.getAttribute('aria-hidden') ?? 'false'
    })
    this.els?.brand?.elements?.forEach((brandEl) => {
      brandEl.dataset.initialHidden =
        brandEl.getAttribute('aria-hidden') ?? 'false'
    })

    if (window.BAO.MediaBreakpoints.isMd) return

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handleClear = this.handleClear.bind(this)
    this.updateClearVisibility = this.updateClearVisibility.bind(this)
    this.onScroll = this.onScroll.bind(this)

    this.listeners.add(this.els?.trigger?.element, 'click', this.handleTrigger)

    this.els?.trigger?.elements?.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', (event) =>
        this.handleTrigger(event),
      )
    })

    if (this.els?.input?.element) {
      this.listeners.add(this.els.input.element, 'input', this.handleSearch)

      this.listeners.add(this.els.input.element, 'keydown', (e) => {
        if (e.key === 'Escape') this.handleClear()
      })
    }

    if (this.els?.clear?.element) {
      this.listeners.add(this.els.clear.element, 'click', this.handleClear)
    }

    if (window.BAO.MediaBreakpoints.isMd) return

    this.listeners.add(window, 'scroll', this.onScroll)
  }

  updateClearVisibility () {
    const hasText = !!(this.els?.input?.element?.value || '').trim()

    if (this.els?.clear?.element) {
      this.els.clear.element.setAttribute(
        'aria-hidden',
        hasText ? 'false' : 'true',
      )
    }
  }

  handleTrigger (event) {
    const clickedTriggerEl = event.target.closest(this.els?.trigger?.selector)
    if (!clickedTriggerEl) return

    this.els?.group?.elements?.forEach((groupEl) => {
      if (groupEl.dataset.group === clickedTriggerEl.dataset.title) {
        groupEl.scrollIntoView({ behaviour: 'smooth', block: 'start' })
      }
    })
  }

  handleSearch (event) {
    const term = (event?.target?.value || this.els?.input?.element?.value || '')
      .trim()
      .toLowerCase()

    this.updateClearVisibility()

    if (!term) {
      this.els?.group?.elements?.forEach((groupEl) => {
        groupEl.setAttribute(
          'aria-hidden',
          groupEl.dataset.initialHidden || 'false',
        )
      })

      this.els?.brand?.elements?.forEach((brandEl) => {
        brandEl.setAttribute(
          'aria-hidden',
          brandEl.dataset.initialHidden || 'false',
        )
      })

      return
    }

    const groupsWithMatch = new Set()

    this.els?.brand?.elements?.forEach((brandEl) => {
      const text = (brandEl.textContent || '').toLowerCase()
      const matches = text.includes(term)
      brandEl.setAttribute('aria-hidden', matches ? 'false' : 'true')

      if (matches) {
        const groupEl = brandEl.closest(
          this.els?.group?.selector || '[data-brands-list-el="group"]',
        )

        if (groupEl) groupsWithMatch.add(groupEl)
      }
    })

    this.els?.group?.elements?.forEach((groupEl) => {
      const hasMatch = groupsWithMatch.has(groupEl)

      groupEl.setAttribute('aria-hidden', hasMatch ? 'false' : 'true')
    })
  }

  handleClear () {
    if (!this.els?.input?.element) return
    this.els.input.element.value = ''

    this.handleSearch({ target: this.els.input.element })

    this.els.input.element.focus()
  }

  onScroll () {
    this.lastKnownY = window.scrollY
    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)
    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setVisibility()
  }

  setVisibility () {
    this.els['fixed-bar'].element.classList.toggle(
      'sec-Brands_FixedBar-hidden',
      !this.shouldBeVisible,
    )
  }

  get shouldBeVisible () {
    if (!this.els?.letters?.exists) return

    const topStart = this.els.letters.element
    const bottomEnd = this.externalEls.footer.element

    if (
      this.lastKnownY > getOffsetTop(topStart) + topStart.offsetHeight &&
      this.lastKnownY < getOffsetTop(bottomEnd) - window.innerHeight
    ) {
      return true
    } else {
      return false
    }
  }
}

if (!customElements.get('brands-list')) {
  customElements.define('brands-list', BrandsList)
}
